import { useState, useEffect } from 'react';
import { AppSpacer } from './AppSpacer';

//  components
import Fade from '@mui/material/Fade';
import Skeleton from '@mui/material/Skeleton';
import AppCopyText from './AppCopyText';

type PropsType = {
  title?: string;
  content?: string;
  isCopyToClipboardBlocked?: boolean;
  sectionLabel?: string;
  maxHeight?: string;
};

export const AppCodeArea = ({
  title = '',
  sectionLabel = '',
  maxHeight = '316px',
  content = '',
  isCopyToClipboardBlocked = false,
}: PropsType) => {
  // make sure that the content can be parsed; if not display it as it is
  const [parsedContent, setParsedContent] = useState<string | null>(null);
  useEffect(() => {
    try {
      setParsedContent(JSON.stringify(JSON.parse(content), null, 2));
    } catch (e) {
      setParsedContent(content);
    }
  }, [content]);

  return (
    <div className='app-code-area'>
      <h2 className='font-18 font-500 mb-0 text-uppercase color-black'>{title}</h2>

      <AppSpacer space='24px' />
      {content ? (
        <>
          <Fade in={!!content}>
            <article className={title ? 'card p-4' : ''}>
              <pre className='code-area mb-0  position-relative' style={{ maxHeight: maxHeight }}>
                <header className='d-flex align-items-center justify-content-between position-sticky top-0 left-0'>
                  {title && <h3 className='font-11 font-400 font-lato mb-0 text-capitalize color-secondaryGrey'>{title}</h3>}
                  {!isCopyToClipboardBlocked && parsedContent ? (
                    <AppCopyText className='ml-1 position-absolute top-10 right-10' text={parsedContent} />
                  ) : null}
                </header>

                <AppSpacer space='5px' />

                {content && parsedContent}
              </pre>
            </article>
          </Fade>
        </>
      ) : (
        <Skeleton variant='rectangular' height={245} />
      )}
    </div>
  );
};

export default AppCodeArea;
